import { Component, Input, OnChanges, SimpleChange } from '@angular/core';
import { Label } from 'ng2-charts';
import { ChartType, ChartDataSets, ChartOptions } from 'chart.js';

@Component({
    selector: 'odl-report-generale',
    templateUrl: './report-generale.component.html',
    styleUrls: ['./report-generale.component.scss']
})
export class ReportGeneraleComponent implements OnChanges {

    public barChartOptions: ChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {display:false}
    };
    public barChartLabels: Label[] = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];
    public barChartType: ChartType = 'bar';
    public barChartLegend = true;
    public barChartPlugins = [];

    public barChartData: ChartDataSets[] = [
        { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }
    ];

    public tableData = [];
    public tableDataSum = 0;

    @Input() data: number[];

    setTable() {
        this.tableData = [
            { label: 'Gennaio', value: this.data[0] },
            { label: 'Febbraio', value: this.data[1] },
            { label: 'Marzo', value: this.data[2] },
            { label: 'Aprile', value: this.data[3] },
            { label: 'Maggio', value: this.data[4] },
            { label: 'Giugno', value: this.data[5] },
            { label: 'Luglio', value: this.data[6] },
            { label: 'Agosto', value: this.data[7] },
            { label: 'Settembre', value: this.data[8] },
            { label: 'Ottobre', value: this.data[9] },
            { label: 'Novembre', value: this.data[10] },
            { label: 'Dicembre', value: this.data[11] },
        ];

        this.tableDataSum = this.data.reduce( (sum, current) => sum + current, 0);

        this.barChartData = [
            { data: this.data }
        ];
    }    

    constructor() {
        this.data = [0,0,0,0,0,0,0,0,0,0,0,0];
        this.setTable();
    }

    ngOnChanges(changes: {[s: string]: SimpleChange}) {
        if ( !changes.data.currentValue ) {
            this.data = [0,0,0,0,0,0,0,0,0,0,0,0];
        }
        this.setTable();
    }
}
